/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */
const React = require('react');
const Button = require('@andes/button');
const Checkbox = require('@andes/checkbox');
const ParamItem = require('./ParamItem');
const ErrorItem = require('./ErrorItem');
const Collapse = require('../../Sidebar/images/Collapse');
const { getEventTracker } = require('../../../../utils/event-tracker');

const { useState, useEffect } = React;

const ParamsContainer = ({ i18n, properties = [], lang, maxItems = 4, response = false, type, codeType, siteId, setUpdateCodeContentRequestFromParams }) => {
  const Tracker = getEventTracker();
  const [showAll, setShowAll] = useState(false);
  const [showData, setShowData] = useState(!response);
  const [checkboxState, setCheckboxState] = useState({
    body: { required: true, optional: true },
    query: { required: true, optional: true },
    path: { required: true, optional: true },
    header: { required: true, optional: true },
  });
  const buttonText = showAll ? i18n.gettext('Ocultar parámetros') : i18n.gettext('Mostrar todo');
  const accordionRef = React.useRef(null);
  const isErrorContainer = type === 'error';
  const errorItemDOMSelector = '.error-item .error-item__children';

  const updateCollapsibleHeight = () => {
    const collapsibleSize = (() => {
      if (isErrorContainer) {
        const errorItemParentHeight = 42;
        const errorItemChildrenHeight = [...accordionRef.current.querySelector(errorItemDOMSelector).children]
          .reduce((acc, child) => acc + child.clientHeight + errorItemParentHeight, 200);
        return errorItemParentHeight + errorItemChildrenHeight;
      }

      return [...accordionRef.current.children].reduce((acc, child) => acc + child.clientHeight, 200);
    })();
    accordionRef.current.style.maxHeight = showData ? `${collapsibleSize}px` : '0px';
  };

  useEffect(() => {
    updateCollapsibleHeight();
  }, [showData, showAll]);

  const clickShow = (callFunction, newValue, typeValue) => {
    callFunction(newValue);
    Tracker.send(`mpdevelopers/content_${typeValue}_params_${response ? 'response' : 'request'}`, newValue ? 'show' : 'hide');
  };

  const getHeaderCollapseText = () => {
    switch (type) {
      case 'request': return i18n.gettext('Parámetros para la solicitud');
      case 'response': return i18n.gettext('Parámetros de respuesta');
      case 'error': return i18n.gettext('Errores');
      default: return '';
    }
  };


  const groupedProperties = isErrorContainer ? properties : properties.reduce((grouped, property) => {
    const key = property.in;
    if (!grouped[key]) {
      grouped[key] = [];
    }
    grouped[key].push(property);
    return grouped;
  }, {});

  return (
    <div className="api-params">
      <div className="api-params--header" onClick={() => { clickShow(setShowData, !showData, 'DATA'); }}>
        <Collapse className={showData ? 'icon__uncollapsed' : 'icon__collapsed'} />
        <span className="title">
          {getHeaderCollapseText()}
        </span>
      </div>
      <div ref={accordionRef} className={`api-params__body ${!showData && 'api-params__body--collapsed'} ${isErrorContainer && 'api-params__body--no-padding'}`}>
        {properties.filter(item => item.type === ' ' && item.in === ' ').map((property) => {
          return (
            <ParamItem i18n={i18n} lang={lang} property={property} onUpdate={updateCollapsibleHeight} siteId={siteId} />
          );
        })}

        {isErrorContainer && properties?.map((property) => {
          return <ErrorItem i18n={i18n} lang={lang} property={property} response={response} onUpdate={updateCollapsibleHeight} />;
        })}

        {!isErrorContainer && Object.keys(groupedProperties).map((inKey) => {
          const isRequired = checkboxState[inKey] && checkboxState[inKey].required;
          const isOptional = checkboxState[inKey] && checkboxState[inKey].optional;


          return (
            <div key={inKey}>
              {
                !isErrorContainer && type === 'request'
                && inKey !== ' ' && <div className="api-body">
                  <div className="session-body">
                    {i18n.gettext(inKey).toUpperCase()}
                  </div>
                  {
                    !isErrorContainer
                    && <div className="session-checkbox">
                      <Checkbox
                        label={i18n.gettext('Obligatorio')}
                        checked={isRequired}
                        onChange={() => setCheckboxState((prevState) => ({
                          ...prevState,
                          [inKey]: { ...prevState[inKey], required: !isRequired },
                        }))}
                      />
                      <Checkbox
                        label={i18n.gettext('Opcional')}
                        checked={isOptional}
                        onChange={() => setCheckboxState((prevState) => ({
                          ...prevState,
                          [inKey]: { ...prevState[inKey], optional: !isOptional },
                        }))}
                      />
                    </div>
                  }
                </div>
              }
              {!isErrorContainer && properties
                .filter(item => (isErrorContainer ? item : (item.in === inKey && ((isRequired && item.required === true) || (isOptional && item.required !== true)))))
                .map((property, index, array) => {
                  if ((index >= maxItems) && !showAll) {
                    return (<></>);
                  }
                  return (
                    <ParamItem
                      i18n={i18n}
                      lang={lang}
                      property={property}
                      type={type}
                      last={index === array.length - 1}
                      onUpdate={updateCollapsibleHeight}
                      codeType={codeType}
                      siteId={siteId}
                      setUpdateCodeContentRequestFromParams={setUpdateCodeContentRequestFromParams} />
                  );
                })}
              {properties.filter(item => item.in === inKey && ((isRequired && item.required === true) || (isOptional && item.required !== true)))?.length > maxItems
                && (
                  <>
                    <div className="show-more" onClick={() => { clickShow(setShowAll, !showAll, 'ALL'); }}>
                      <Button className="button-show-more" fullWidth>
                        {buttonText}
                        <Collapse className={!showAll ? 'icon__uncollapsed' : 'icon__collapsed'} />
                      </Button>
                    </div>
                  </>
                )}
            </div>
          );
        })}

      </div>
    </div>
  );
};

module.exports = ParamsContainer;
